module.exports = __webpack_public_path__ + "static/media/Landmark 2 750x774.74ee339a.png";